module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ttl2",
    staticStyle: {
      "margin-top": "15%"
    },
    attrs: {
      "id": "c15"
    }
  }, [_vm._v("Seven")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    staticStyle: {
      "margin-top": "7%"
    }
  }, [_vm._v("Richmond Davidson awoke. It was dark and quiet. He had no idea of the hour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His mind had been plaguing him most of the night with thoughts about his conversation with Carolyn on the way back from the station.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His own words haunted him. "), _c('i', [_vm._v("Perhaps the best solution would be to set him free.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He had said it without thinking. Yet might it in fact be the best thing to do, the perfect solution to a difficult problem? On the other hand, what kind of precedent would it set? How would their other slaves respond? And what of the legal ambiguities? Virginia’s laws regarding freeing slaves may have been more lenient than those of some states in the Deep South. But they were not without their complexities."), _c('sup', {
    attrs: {
      "id": "q1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Endnotes#p1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It would be a relief to be rid of Elias, that could not be denied. The investment would seem a small price now to be free from the grief the big black man was causing. If he seriously intended to pursue the offer that had been made two days ago, Davidson had to know things could run smoothly at Greenwood during the inevitable absences a Senate seat would necessitate. Why should he not simply give Elias a document releasing him and put him on a train anywhere he wanted to go? As far as reaction among the other slaves, he could simply send him away without telling the rest of them anything. On the political side of it, might such a move instantly ruin his political stand… or, if a national reputation of moderation was what they wanted, perhaps freeing Elias would "), _c('i', [_vm._v("enhance")]), _vm._v(" his standing rather than damage it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wide range of potential implications was confusing!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("God, what do you want me to do?")]), _vm._v(" he sighed inaudibly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His mind full of the many decisions facing him, as well as those that might be forced upon him, Davidson drifted into an uneasy sleep. The rest of the night passed fitfully.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later that morning as he sat with coffee in hand perusing the newspaper, a caption caught his eye. He began reading the article beneath it with interest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Listen to this, Carolyn,” he said after several minutes. “A symposium is being held in Boston on the spiritual pros and cons of slavery. Martin Wingate will be one of the featured speakers.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The theologian from England?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The very same.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Haven’t I heard you mention him more than once?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I met him as a young man when I was overseas. I would dearly love to see him again. There will also be representatives from both Northern and Southern states and several different church groups, all offering their perspectives on the basis of the pros and cons from Scripture. That should be quite a meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It sounds fascinating. Why don’t you attend?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Davidson laughed. “I told you… it’s in Boston.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You could go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All that way?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why not? Maybe the break would be good for you. You always say that getting away once in a while helps clear your brain.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not always,” laughed Davidson. “The trip down to North Carolina sent me into a turmoil of reflection I have not been able to get out of.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You know what I mean—when you go away alone, to think and pray and be with God. With this decision before you about the Senate, I think such a trip might be the perfect thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wonder what the weather is like in New England in April. Hmm… well I shall think about it,” chuckled her husband. “I must say, a trip to Boston is the last thing I anticipated when I awoke this morning!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11457e68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Seven.vue
// module id = 108
// module chunks = 0